import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from "../utils/api";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MenuContent from '../layouts/MenuContent';

export default function SideMenuMobile({ open, toggleDrawer }) {
    const location = useLocation();
    const { _logout, _deleteUser, _getUser } = useAuth();
    const navigate = useNavigate();
    const [user, setUser] = useState(_getUser() || null);

    // Check if token is in URL and fetch user data if needed
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tokenFromUrl = urlParams.get('token');
        
        const fetchUserFromToken = async () => {
            if (tokenFromUrl) {
                try {
                    // Fetch user data using the token from URL
                    const response = await api.get('user/me');
                    const userData = response.data.data;
                    // Store in component state only (not localStorage to avoid affecting super admin tab)
                    setUser(userData);
                } catch (error) {
                    console.error('Failed to fetch user from token:', error);
                    // Fallback to localStorage user if fetch fails
                    const storedUser = _getUser();
                    if (storedUser) {
                        setUser(storedUser);
                    }
                }
            } else {
                // Use user from localStorage if no token in URL
                const storedUser = _getUser();
                if (storedUser) {
                    setUser(storedUser);
                }
            }
        };

        fetchUserFromToken();
    }, [location.search, _getUser]);

    const handleLogout = async () => {
        try {
            await api.delete("/session/destroy");
            _logout();
            _deleteUser();
            navigate("/login")
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={toggleDrawer(false)}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                [`& .${drawerClasses.paper}`]: {
                    backgroundImage: 'none',
                    backgroundColor: 'background.paper',
                },
            }}
        >
            <Stack
                sx={{
                    maxWidth: '70dvw',
                    height: '100%',
                }}
            >
                {user && (
                    <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
                        <Stack
                            direction="row"
                            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
                        >
                            <Avatar
                                sizes="small"
                                alt={user.name || user.email}
                                src="/static/images/avatar/7.jpg"
                                sx={{ width: 24, height: 24 }}
                            />
                            <Typography component="p" variant="h6">
                                {user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'User'}
                            </Typography>
                        </Stack>
                    </Stack>
                )}
                <Divider />
                <Stack sx={{ flexGrow: 1 }}>
                    <MenuContent />
                    <Divider />
                </Stack>
                {/* <CardAlert /> */}
                <Stack sx={{ p: 2 }}>
                    <Button
                        onClick={handleLogout}
                        variant="outlined"
                        fullWidth
                        startIcon={<LogoutRoundedIcon />}>
                        Logout
                    </Button>
                </Stack>
            </Stack>
        </Drawer>
    );
}
